export default {
  nav: {
    home: 'トップ',
    block: 'ブロック',
    viewblock: 'ブロックビューする',
    viewtx: '取引ビューする',
    token: 'トークン',
    rank: 'ホルダーランキング',
    tool: 'ツール',
    analysis: '取引解析',
    broadcast: '取引ブロードキャスト'
  },
  footer: {
    txt: 'ブロックチェーンエクスプローラーは、ブロックデータの調査分析ができるプラットフォームです。'
  },
  page: {
    first: 'トップ',
    last: '最後',
    confirm: '確定',
    nodata: '記録なし'
  },
  components: {
    hour: '時間',
    hours: '時間',
    min: '分',
    mins: '分',
    sec: '秒前',
    secs: '秒前',
    copy: 'コピー',
    tip: 'ヒント',
    noMsg: '取引情報が見付かりません',
    repeat: 'リトライ',
    copySuc: 'コピーできました',
    copyErr: 'コピー失敗',
    allBlock: '全ブロック',
    blockDetail: 'ブロック詳細',
    succ: '成功',
    fail: '失敗',
    errMsg: '情報入力エラー、再度お試しください',
    errAdr: 'アドレスエラー',
    errParam: 'パラメータエラー',
    errToken: 'このトークンがありません',
    errRequest: 'データリクエスト失敗',
    errTxt: '取引テキストは入力必須',
    errHeight: '入力のブロック高さは現在最大の高さを超えてはいけません',
    errFormat: 'フォーマットエラー、取引の16進数形式テキストを入力してください',
    footer: 'ブロックチェーンエクスプローラーは、ブロックデータの調査分析ができるプラットフォームです。'
  },
  home: {
    title: 'エクスプローラー',
    keyword: 'アドレス/取引ハッシュ/ブロックの高さを入力ください',
    search: '検索',
    blockTitle: '最新のブロック',
    txCount: '取引回数',
    time: '時間',
    txTitle: '最新の取引',
    txHash: '取引ハッシュ',
    sender: '送付側',
    receiver: '受取側',
    txValue: '取引金額',
    viewAll: 'すべてをビューする'
  },
  block: {
    title: '全ブロック',
    count: '個ブロック',
    height: '高さ',
    time: 'ブロックタイム',
    hash: 'ブロックハッシュ',
    txCount: '取引数量'
  },
  blockDetail: {
    title: '高さ',
    general: '概要',
    last: '一個前のブロック',
    next: '次のブロック',
    mock: 'メルケルルート',
    statusHash: 'ステータスハッシュ',
    record: '記録',
    nodata: 'なし'
  },
  trade: {
    title: '全取引',
    count: '回の取引',
    totalTip: '全部',
    tip: '最近の10万回を表示',
    hash: '取引ハッシュ/',
    sender: '送付側',
    receiver: '受取側',
    num: '数量',
    fee: '手数料',
    func: '関数を呼び出す',
    time: '時間',
    token: 'トークン'
  },
  txDetail: {
    title: '取引詳細',
    status: 'ステータス',
    success: '書込み成功、執行成功',
    faild: '書込み成功、執行失敗',
    value: '価値',
    random: 'ランダム数',
    execer: 'アクチュエータ',
    txType: '取引タイプ',
    normalTx: '一般取引',
    groupTx: '取引グループ',
    inData: '入力データ',
    outData: '出力データ'
  },
  address: {
    nav: '個人アドレス',
    title: 'アドレス',
    tag: 'ラベル',
    save: 'QRコード保存',
    balance: '残高',
    placeholder: 'コントラクトを選択してください',
    frozen: '凍結',
    txCount: '取引回数',
    total: 'トークン合計価値',
    about: 'およそ',
    tokenPlaceholder: 'トークン略称を入力ください',
    record: '記録',
    tokenRecord: 'トークン取引記録',
    txTotal: '{0}回の取引が見つかりました',
    last: '最近の{0}万回を表示',
    allTx: '全取引',
    succTx: '成功取引をビューする',
    failTx: '失敗取引をビューする',
    sendTx: '送付の取引をビューする',
    receTx: '受取の取引をビューする'
  },
  token: {
    title: 'トークン',
    mainToken: 'メイントークン',
    holder: 'ホルダー',
    time: '時間',
    introduce: 'トークン紹介',
    tokenList: 'トークンリスト',
    keyword: 'トークン略称を入力ください',
    total: '合計{0}種類のトークン',
    id: 'ID'
  },
  tokenDetail: {
    title: 'トークン詳細',
    issueTotal: '発行総数',
    holder: 'ホルダー',
    issueTime: '発行時間',
    point: '小数点',
    value: '価値',
    screen: 'ホルダーによるフィルター',
    viewChart: 'チャートをビューする'
  },
  rank: {
    title: 'ホルダー',
    holderNum: '数量',
    range: '範囲',
    best: 'ベスト',
    type: 'タイプ',
    token: 'トークン',
    holderRank: 'ホルダーランキング',
    mineRank: 'マイニングランキング',
    topHolder: 'トップホルダー {0} が合計 {1} の{2}を所有しています',
    totalTip: 'トークン合計数',
    holderTip: 'ホルダー合計数',
    ps: 'ランキング{0}位のアドレスが合計 {1} のトークンを所有しています( 総量{2}の中から)',
    rank: 'ランキング',
    adr: 'アドレス',
    num: '数量',
    percent: 'パーセント'
  },
  analysis: {
    title: '取引解析',
    tip: 'このページでは、未署名のソーストランザクションを入力できます。16進形式のテキストは、読み取り可能な形式に解析されます。'
  },
  broadcast: {
    title: '取引ブロードキャスト',
    tip: 'このページでは、未署名のソーストランザクションを入力できます。16進形式のテキストは、読み取り可能な形式に解析されます。',
    ps: '、ブロードキャストする前にトランザクションテキストの確認をお勧めします',
    notice: 'ヒント：',
    link: 'トランザクションを解析し',
    btn: '取引を送信'
  }
}